import InactiveFlag from './InactiveFlag';

export default InactiveFlag;
